import { VImg } from 'vuetify/lib/components/VImg';
import { VOverlay } from 'vuetify/lib/components/VOverlay';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VImg,{attrs:{"dark":"","eager":"","src":require("@/assets/images/events/EventsHeader.jpg")}},[_c(VOverlay,{attrs:{"absolute":"","opacity":"0.2"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }